import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const HeroHeaderStyles = makeStyles((theme) => ({
  container: { textAlign: "center", margin: "50px 0" },
  heading: {},
  content: {
    color: COLORS.DARK_GRAY_2,
    "& a": {
      color: COLORS.BLACK,
      textDecoration: "underline"
    }
  }
}));

export default HeroHeaderStyles;
